import { auth } from "@/config/firebase";
import { useUser } from "@/context/user";
import { useFormStatus } from "@dippi/forms";
import { getRoutes } from "@/utils/helpers";
import { log } from "@/utils/logger";
import storage from "@/utils/storage";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useHeader = () => {
    const logout = useUser(state => state.logout);
    const setGlobalLoading = useUser(state => state.setGlobalLoading);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const routes = getRoutes();
    const navigate = useNavigate();
    const currentPath = useLocation().pathname;

    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");

    const isDirty = useFormStatus(state => state.isDirty);
    const setModal = useFormStatus(state => state.setModal);

    const onOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const onCloseMenu = () => {
        setAnchorEl(null);
    };

    const onLogout = async () => {
        try {
            setGlobalLoading(true);
            await auth.signOut();

            logout();
            navigate(routes.signIn);
        } catch (e) {
            log.error(e, "onLogout");
        } finally {
            setGlobalLoading(false);
        }
    };

    const onMenu = (route: string) => {
        if (route === currentPath) return;

        if (isDirty) return setModal(true, route);
        navigate(route);
    };

    const onSwitch = () => {
        if (isDirty) return setModal(true, routes.organizations);

        navigate(routes.organizations);
    };

    const onLogo = () => {
        if (!authenticated) return;

        if (isDirty) return setModal(true, routes.brands());
        if (!oid) return navigate(routes.organization);

        navigate(routes.brands());
    };

    return {
        anchorEl,
        onOpenMenu,
        onCloseMenu,
        onLogout,
        onLogo,
        onMenu,
        onSwitch,
    };
};

export { useHeader };
